<template>
  <!-- <b-card :header="caption"> -->
  <div style="width: 50%;">
    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="receiveFroms" :fields="fields">
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
      </template>
      <template slot="編集" slot-scope="data">
        <b-button v-if="data.item['編集']" @click="edit(data.item)" variant="link" class="pointer" size="lg">
          <i class="fa fa-edit"></i></b-button>
      </template>
    </b-table>
  </div>
  <!-- </b-card> -->
</template>

<script>
// import IntegrationStore from "../../store/integration";

const bindReceiveFroms = (self) => {
  const receiveFroms = [];
  const integration = self.integration;
  if (integration) {
    console.log(integration.IntegrationId);
  }
  if (!integration.ReceiveFroms) {
    integration.ReceiveFroms = [
      {"ReceiveMethod": "", "ReceiveParams": "{}", "ReceiveFromId": ""}
    ];
  }

  for (const integrationReceiveFrom of integration.ReceiveFroms) {
    let item = {
      "編集": true,
      "送信元ID": integrationReceiveFrom.ReceiveFromId,
      "受信手段": integrationReceiveFrom.ReceiveMethod,
      "受信パラメータ": integrationReceiveFrom.ReceiveParams
    };
    receiveFroms.push(item);
  }
  // console.dir(receiveFroms)

  return receiveFroms;
};

export default {
  name: 'c-table-receive-from',
  props: {
    integration: {
      type: Object,
      default: null
    },
    caption: {
      type: String,
      default: 'TableReceiveFrom'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      receiveFroms: bindReceiveFroms(this),
      fields: [
        {key: '編集'},
        {key: '送信元ID'},
        {key: '受信手段'},
        {key: '受信パラメータ'}
      ],
      totalRows: 0
    }
  },
  created() {
    // debugger
    // console.log(this.integration)
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    update() {
      this.receiveFroms = bindReceiveFroms(this)
    },
    edit(receiveFrom) {
      // console.dir(receiveFromId)
      this.$emit('edit', receiveFrom)
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/TableReceiveFrom.vue